import type { Message } from '@flock-types/chat.types';

/**
 * One-shot handoff for "Privately Reply": the context menu creates/opens the
 * DM (a different conversation/route), and the DM's ConversationPane consumes
 * the quoted message as its initial reply state on mount.
 */
let stash: { chatGroupId: string; message: Message } | null = null;

export function stashPendingReply(chatGroupId: string, message: Message): void {
  stash = { chatGroupId, message };
}

export function consumePendingReply(chatGroupId: string | null): Message | null {
  if (stash && stash.chatGroupId === chatGroupId) {
    const message = stash.message;
    stash = null;
    return message;
  }
  return null;
}
